export const ROLES = [
    'spc-support',
    'spc-ga',
    'spc-gm',
    'spc-reader',
    'spc-technical-admin',
    'spc-production-admin',
    'spc-key',
    'spc-sitekey',
    'spc-factory-manager',
    'spc-factory-supervisor',
    'spc-line-supervisor',
    'spc-line-operator',
    'spc-technical-operator',
    'spc-ca',
    'spc-clusterdv',
    'spc-countrydv',
    'spc-deo',
    'spc-sitedv'
];
